export const temporaryTranslations = {
  LBL0174:
    "Your order is now being processed. Please wait for a confirmation email to start using your eSIM.",
  "LBL0287": "Reset password link has been sent to your registered email address",
  "appStoreLink": "https://apps.apple.com/app/esimcrew/id6504028276",
  "playStoreLink": "https://play.google.com/store/apps/details?id=com.bluehouse.eSIMCrew&pli=1"
};
